
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"25","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"share2-a","d":"M18.754 6.126L12.628 0v3.674C-1.17 4.847.026 18.098.026 18.098c2.572-8.744 9.97-9.405 12.602-9.353v3.507l6.126-6.126z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(3.333 3.333)"}},[_c('mask',{attrs:{"id":"share2-b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#share2-a"}})]),_c('use',{attrs:{"fill":"#020203","xlink:href":"#share2-a"}}),_c('g',{attrs:{"fill":"#000","mask":"url(#share2-b)"}},[_c('path',{attrs:{"d":"M-3.333-3.333h25v25h-25z"}})])])])
          )
        }
      }
    